import React, { useState } from "react";
import "./BookingFormData.css";
import { Link } from "react-router-dom";

export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (

    <div className="header">

      <div className="header-container">

        {/* LOGO */}
        <div className="logo">
          Ranthambore Tours & Safari Experiences
        </div>


        {/* HAMBURGER BUTTON */}
        <div 
          className="hamburger"
          onClick={toggleMenu}
        >
          {menuOpen ? "✕" : "☰"}
        </div>


        {/* LEFT + RIGHT COMBINED FOR MOBILE */}
        <div className={`nav-wrapper ${menuOpen ? "open" : ""}`}>




           {/* LEFT */}
          {/* <div className="header-left"> */}

          

              
              {/* <a 
              href="tel:+91XXXXXXXXXX"
                className="testing"
                onClick={closeMenu}
              >
              +91-9217691062
              </a>
            

            <a
              href="https://wa.me/919217691062"
              className="header-whatsapp"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
            >
              WhatsApp
            </a> */}

          {/* </div> */}

          {/* RIGHT */}
          <div className="header-right">

            <Link 
              to="/" 
              className="testing"
              onClick={closeMenu}
            >
              Home
            </Link>

            <Link 
              to="/" 
              className="testing"
              onClick={closeMenu}
            >
              Tour Packages
            </Link>

            <Link 
              to="/jeep-safari-ranthambore" 
              className="testing"
              onClick={closeMenu}
            >
              Jeep Safari Guide
            </Link>

            <Link 
              to="/canter-safari-ranthambore" 
              className="testing"
              onClick={closeMenu}
            >
              Canter Safari Guide
            </Link>


            <a 
              href="mailto:booking@ranthamboresafari.com" 
              className="testing"
              onClick={closeMenu}
            >
              Call Us
            </a>

            <a 
              href="tel:+919217691062"
                className="testing"
                onClick={closeMenu}
              >📞{" "}
              +91-9217691062
              </a>
            

            <a
              href="https://wa.me/919217691062"
              className="header-whatsapp"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
            >
              WhatsApp
            </a>

          </div>


         

        </div>

      </div>

    </div>

  );

}
